export * from "./tci-tenant.module";
export * from "./tci-contrib.service";
export * from "./tci-contrib.model";
export * from "./tci-contrib-request.service";
export * from "./tci-tenant-services";
export * from "./tci-tenant-component-loader.component";
export * from "./tci-tenant-components";
export * from "./tci-contrib-module.map";
export * from "./tci-tenant-service-loader";
export * from "./tci-tenant.model";
export * from "./tci-tenant.service";
export * from "./ng-shared-services/index";
export * from "./tci-tenant-remote-services";
export * from "./tci-tenant.menu";
export * from "../tci-tenant-apps-route-activator";
export * from "./tci-tenant-route-de-activator.service";
export * from "./tci-tenant-component-cache.service";
export * from "./tci-tenant-component";

export * from "@ngx-translate/core";
